import axios from 'axios';
import store from '@/store';

// export const API_URL = `http://localhost:8000/api`
export const API_URL = process.env.VUE_APP_URL || `/api/`

const $api = axios.create({
    withCredentials: true,
    baseURL: API_URL
})

$api.interceptors.request.use((config) => {
    const token = store.getters.userToken || localStorage.getItem('token')

    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }

    return config;
})

$api.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token')
            localStorage.removeItem('role')
            store.commit('unauthenticateUser')
            window.location.href = '/login'
        }

        return Promise.reject(error)
    }
)

export default $api;
